module.exports = __webpack_public_path__ + "static/media/tk.e37e35bf.svg";